import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedDaysAhead.errors.";

const ticketAutomationReceivedDaysAheadCalendarsSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error:
      translationPath + "ticketAutomationReceivedDaysAheadCalendars",
  },
);
const ticketAutomationReceivedDaysAheadInsurancesSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error:
      translationPath + "ticketAutomationReceivedDaysAheadCalePreferences",
  },
);
const ticketAutomationReceivedDaysAheadProceduresSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error:
      translationPath + "ticketAutomationReceivedDaysAheadCaleProcedures",
  },
);

const timeLimitTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string(),
});

export const automationReceivedConfFileSchema = z.object({
  id: z.string().optional(),
  automationCode: z.string().optional(),
  qtDays: z.string().min(1, translationPath + "qtd_days"),
  enable: z.boolean(),
  limitFinalDate: z.boolean(),
  timeLimitType: timeLimitTypeSchema.nullish(),
  limitMonths: z.string().nullish(),
  ticketAutomationReceivedDaysAheadCalendars: z
    .array(ticketAutomationReceivedDaysAheadCalendarsSchema)
    .nullish(),
  ticketAutomationReceivedDaysAheadInsurances: z
    .array(ticketAutomationReceivedDaysAheadInsurancesSchema)
    .nullish(),
  ticketAutomationReceivedDaysAheadProcedures: z
    .array(ticketAutomationReceivedDaysAheadProceduresSchema)
    .nullish(),
});

export type TAutomationReceivedDaysAheadForm = z.infer<
  typeof automationReceivedConfFileSchema
>;
